import { useEffect, useState } from 'react';
import { Routes, Route, Outlet, useLocation, } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import 'moment/locale/pt-br'
import { ThemeProvider } from '@mui/material/styles';
import ReactGA from 'react-ga4';

import currentTheme				from './context/theme'

import TransactionsFixedIncome 	from './TransactionsFixedIncome';
import SideMenu 				from './components/SideMenu';
import TopMenu 					from './components/TopMenu';
import OperationsLogs 			from './OperationLogs';
import OperationsLogsDetail 	from './OperationLogsDetail';
import Notifications 			from './Notifications';
import Bonds 					from './Bonds';
import BankSavings				from './BankSavings';
import Login 					from './views/User/Login';
import RequireAuth 				from './components/RequireAuth';
import OperationPanel			from './OperationPanel';

import Dashboard 				from './views/Dashboard';
import StockScreener 			from './views/StockScreener'

// Telas ja migradas para novo padrao
import Company	 				from './views/Company'
import Transactions 			from './views/Transactions';
import Portfolio 				from './views/Portfolio';
import Dividends 				from './views/Dividends';

import Feed 					from './views/Feed';
import Register 				from './views/User/Register';
import Verify 					from './views/User/Verify';
import RecoverPassword 			from './views/User/RecoverPassword';
import ChangePassword 			from './views/User/ChangePassword';
import UserSettings 			from './views/User/UserSettings';
import Subscription 			from './views/Subscription';
import UserData 				from './views/User/UserData';
import Home 					from './views/Home';
import ContentDetail			from './components/Content/ContentDetail';
import Content 					from './components/Content';
import OptionalAuth 			from './components/OptionalAuth';
import ThrottlingError 			from './components/ThrottlingError';
import NotFoundError 			from './components/NotFoundError';
import Rankings 				from './views/Rankings';
import Calendar				from './views/Calendar';

function App() {

	const [open, setOpen] 	= useState(false)
	const location 			= useLocation()

	ReactGA.initialize('G-H9E5KVJZQB'); 
	ReactGA.send("pageview");

	useEffect(() => {
		ReactGA.send("pageview");
	}, [location])

	const handleDrawerClose = () => {
		setOpen(false)
	}

	const handleDrawerOpen = () => {
		setOpen(true)
	}

	return (
		<LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='pt-br'>
			<ThemeProvider theme={currentTheme}>
				<Routes>
					<Route
						element={
						<AppLayout
							open={open}
							setOpen={setOpen}
							handleDrawerOpen={handleDrawerOpen}
							handleDrawerClose={handleDrawerClose}
						/>
						}
					>
						{/* Rotas protegidas */}
						<Route element={<RequireAuth />}>
							<Route path="/transactions/:type" element={<Transactions />} />
							<Route path="/transactionsFixedIncome/:market" element={<TransactionsFixedIncome />} />
							<Route path="/bonds/:country" element={<Bonds />} />
							<Route path="/bankSavings" element={<BankSavings />} />
							<Route path="/operationLogs" element={<OperationsLogs />} />
							<Route path="/operationLogs/:date" element={<OperationsLogsDetail />} />
							<Route path="/operationPanel" element={<OperationPanel />} />
							<Route path="/notifications" element={<Notifications />} />
							<Route path="/dashboard" element={<Dashboard />} />
							<Route path="/portfolio" element={<Portfolio />} />
							<Route path="/portfolio/:assetType" element={<Portfolio />} />
							<Route path="/stockscreener" element={<StockScreener />} />
							<Route path="/dividends" element={<Dividends />} />
							<Route path="/changePassword" element={<UserData />} />
							<Route path="/userData" element={<UserData />} />
							<Route path="/user/settings" element={<UserSettings />} />
							<Route path="/subscription/:subscriptionId" element={<Subscription />} />
							<Route path="/subscription" element={<Subscription />} />
						
							<Route path="/test" element={<ContentDetail />} />
						</Route>

						{/* Rotas com login opcional */}
						<Route element={<OptionalAuth />}>
							<Route path="/company/:ticker" element={<Company />} />
							<Route path="/content/:file" element={<ContentDetail />} />
							<Route path="/rankings" element={<Rankings />} />
							<Route path="/stockscreener/:screenerId" element={<StockScreener />} />
							<Route path="/calendar" element={<Calendar />} />
						</Route>

						{/* Rotas públicas */}
						<Route path="/" element={<Home />} />
						<Route path="/contents" element={<Content />} />
						<Route path="/login" element={<Login />} />
						<Route path="/register" element={<Register />} />
						<Route path="/verify/:token" element={<Verify />} />
						<Route path="/verify" element={<Verify />} />
						<Route path="/changePassword/:token" element={<ChangePassword />} />
						<Route path="/recoverPassword" element={<RecoverPassword />} />

						{/* Rotas para erros */}
						<Route path="/error/tooManyRequests" element={<ThrottlingError/>}/>
						<Route path="*" element={<NotFoundError/>}/>

					</Route>
				</Routes>
			</ThemeProvider>

		</LocalizationProvider>
	) 
	
}

const AppLayout = ({ open, setOpen, handleDrawerOpen, handleDrawerClose }) => {
  return (
	<>
	  	<TopMenu handleDrawerOpen={handleDrawerOpen} />
	  	<SideMenu
			open={open}
			setOpen={setOpen}
			handleDrawerOpen={handleDrawerOpen}
			handleDrawerClose={handleDrawerClose}
		/>
		<main style={{ marginTop: 80, marginLeft: 0, marginBottom: 0, paddingBottom: 4 }}>
			<Outlet />
		</main>
	</>
  );
}

export default App;
